module.exports = __webpack_public_path__ + "img/59d2480.jpg";